import { getServerInfo } from '../utils/helpers/networkInfo.helper'

const blobStorageUrl = getServerInfo('blob')

// Definir los buckets disponibles
export const BUCKETS = {
  LABORATORY: 'bucket-prove-elvira',
  USER_FILES: 'user-files',
  TEMPORARY: 'temporary-files',
  // Agregar más buckets según necesites
}

export class FilesService {
  static getByName(filename, bucket = BUCKETS.LABORATORY) {
    // Validar que el bucket exista
    if (!Object.values(BUCKETS).includes(bucket)) {
      console.error(`Bucket ${bucket} no existe`)
      return null
    }
    return `${blobStorageUrl}${bucket}/${filename}`
  }

  // Método para verificar si un archivo existe en un bucket específico
  static async checkFileExists(filename, bucket = BUCKETS.LABORATORY) {
    const url = this.getByName(filename, bucket)
    if (!url) return false

    try {
      const response = await fetch(url, { method: 'HEAD' })
      return response.ok
    } catch (error) {
      console.error(`Error al verificar archivo en bucket ${bucket}:`, error)
      return false
    }
  }

  // Método para obtener la URL de un archivo de laboratorio (método específico)
  static getLaboratoryFile(filename) {
    return this.getByName(filename, BUCKETS.LABORATORY)
  }

  // Método para obtener la URL de un archivo de usuario
  static getUserFile(filename) {
    return this.getByName(filename, BUCKETS.USER_FILES)
  }

  // Método para obtener la URL de un archivo temporal
  static getTemporaryFile(filename) {
    return this.getByName(filename, BUCKETS.TEMPORARY)
  }
}
